import { render, staticRenderFns } from "./Sanitaerbereich.vue?vue&type=template&id=715859a2"
import script from "./Sanitaerbereich.vue?vue&type=script&lang=js"
export * from "./Sanitaerbereich.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports